import { render, staticRenderFns } from "./LoadingScene.vue?vue&type=template&id=18920aec&scoped=true&"
import script from "./LoadingScene.vue?vue&type=script&lang=js&"
export * from "./LoadingScene.vue?vue&type=script&lang=js&"
import style0 from "./LoadingScene.vue?vue&type=style&index=0&id=18920aec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18920aec",
  null
  
)

export default component.exports